import React from 'react';
import Product from "../components/Product";
import { ProfilesIcon2 } from "../assets/imageAssets";

const TOPICS = [
    {
        id: 1,
        title: 'Life Satisfaction Score',
        description: 'Measure your overall life satisfaction and compare it to national and global averages.',
    },
    {
        id: 2,
        title: 'Emotional Well-being',
        description: 'Evaluate your emotional health and discover how it compares with the general population.',
    },
    {
        id: 3,
        title: 'Happiness Factors',
        description: 'Identify key happiness factors and see how your results align with broader trends.',
    },
    {
        id: 4,
        title: 'Satisfaction with Daily',
        description: 'Reflect on your daily life experience and benchmark it against country-wide averages.',
    },
    {
        id: 5,
        title: 'Satisfaction by Age Group',
        description: 'Compare your life satisfaction score to others within your age group and demographic.',
    },
];

const LifeSatisfactionScanner = () => {
    return (
        <Product
            title={'Life Satisfaction Scanner'}
            description={'See how citizens across Europe rate their quality of life — from career to community.'}
            icon={ProfilesIcon2}
            pageColor={'orange'}
            topicsList={TOPICS}
        />
    );
}

export default LifeSatisfactionScanner;
